<template lang="html">
	<div class="directives">
		<div class="distance">{{ $t('approxDistance') }} {{ distance }} {{ $tc('distUnit', distance) }}</div>
	</div>
</template>
<script>
import { getLocalizedDistance } from '@/plugins/i18n.js';
export default {
	name: 'SpotitemDirective',
	props: {
		spot: Object
	},
	data: () => ({
		distance: 0
	}),
	created: function () {
		this.distance = getLocalizedDistance(this.spot.distance);
	}
}
</script>
<style lang="scss" scoped>
.directives {
	width:100%;
	margin-bottom:1em;
	.distance {
		color: #aaa;
	}
}
</style>